<!-- 
The Profile page for a logged in user.
-->
<template>
  <div class="home">
    <our-heading title="My profile" />
    <mfa-profile-panel />
  </div>
</template>

<script>
import MfaProfilePanel from "@/components/users/MfaProfilePanel.vue";

export default {
  name: "MyProfile",
  components: { 
    MfaProfilePanel
  },
  computed: {
    state() {
      return this.$store.state.prismsUsers.viewMfaProfile;
    },
    environment() {
      return this.$store.getters.environmentForToolbar;
    }
  }
};
</script>
